export default [
    ['襲', '龔'],
    ['斯', '欺'],
    ['冲', '沖'],
    ['栃', '杤'],
    ['蓮', '連'],
    ['開', '閑', '問', '間', '閉', '閣', '閏', '閠', '関', '閥', '閧', '閬', '閭', '閻', '閼', '閾', '闊', '闇', '誾', '闘'],
    ['淵', '渕'],
    ['崞', '嵉', '崹'],
    ['雅', '稚'],
    ['場', '塲', '埸'],
    ['及', '乃'],
    ['宮', '宫', '官'],
    ['驰', '弛', '馳'],
    ['里', '理'],
    ['妍', '姸', '妡', '娇'],
    ['尔', '尓'],
    ['蒲', '浦'],
    ['鶴', '霸', '靏', '靍', '霧', '覊', '篝'],
    ['柘', '拓'],
    ['稙', '植'],
    ['曹', '曺'],
    ['瑋', '偉', '璋'],
    ['波', '渡'],
    ['沫', '洙'],
    ['後', '俊'],
    ['祟', '崇'],
    ['濔', '濔'],
    ['情', '倩'],
    ['梁', '簗'],
    ['筆', '篳', '肇'],
    ['吞', '呑'],
    ['温', '溫'],
    ['股', '殷'],
    ['樽', '尊', '榑', '博'],
    ['船', '舩'],
    ['舌', '吉', '𠮷'],
    ['舌', '告'],
    ['吉', '告'],
    ['𠮷', '告'],
    ['抽', '柚'],
    ['玟', '玫'],
    ['鄉', '鄕', '郷'],
    ['瀬', '瀨'],
    ['郁', '都', '都'],
    ['鋒', '鉾'],
    ['騨', '彈'],
    ['擊', '撃'],
    ['艶', '艷'],
    ['総', '聡'],
    ['鷲', '鷺'],
    ['澵', '新'],
    ['品', '晶'],
    ['玲', '怜'],
    ['娅', '姃'],
    ['梛', '椰'],
    ['材', '村'],
    ['晋', '普'],
    ['炯', '烔'],
    ['飲', '斂'],
    ['影', '彰'],
    ['涬', '滓'],
    ['州', '洲'],
    ['膳', '勝'],
    ['则', '則'],
    ['或', '彧'],
    ['諫', '諌'],
    ['堅', '竪'],
    ['頴', '穎'],
    ['洸', '光'],
    ['仔', '伃'],
    ['傳', '傅'],
    ['桒', '莱', '菜'],
    ['竞', '尭'],
    ['湖', '瑚'],
    ['于', '子', '予', '宇', '乎'],
    ['粕', '柏'],
    ['替', '賛'],
    ['丹', '舟'],
    ['弐', '貳'],
    ['二', 'ニ'],
    ['余', '金'],
    ['烽', '煒'],
    ['侑', '倩'],
    ['漠', '獏', '模', '貘'],
    ['錦', '銀'],
    ['闫', '闰'],
    ['綱', '網'],
    ['瓜', '爪'],
    ['微', '徴', '徽', '薇'],
    ['従', '從', '徒'],
    ['鹏', '鵬'],
    ['鍼', '鋮'],
    ['吕', '呂', '昌', '畠'],
    ['球', '珠'],
    ['余', '佘'],
    ['薫', '薰'],
    ['錦', '綿'],
    ['口', '囗', 'ロ'],
    ['起', '紀', '記'],
    ['池', '地'],
    ['り', 'リ'],
    ['賴', '頼', '赖'],
    ['纮', '絋', '鉱', '紘'],
    ['司', '可', '河', '何', '荷'],
    ['文', '丈', '𠀋'],
    ['央', '史', '吏'],
    ['說', '説'],
    ['薛', '薜'],
    ['籏', '簱', '旗'],
    ['顯', '顕', '頭'],
    ['鳥', '烏', '島', '嶋', '蔦', '嶌', '嶺', '爲', '為'],
    ['陣', '陳'],
    ['粂', '乘', '乗'],
    ['紗', '沙', '抄', '砂'],
    ['绘', '絵'],
    ['億', '憶'],
    ['䑓', '基', '堇', '菫', '董', '臺', '薹'],
    ['恭', '泰', '康', '秦', '奏'],
    ['門', '円'],
    ['道', '進', '逝', '遂', '遷', '遡'],
    ['環', '璟'],
    ['纓', '櫻'],
    ['相', '柑'],
    ['延', '廷', '𨒌'],
    ['堀', '掘'],
    ['濃', '儂'],
    ['千', '干'],
    ['亭', '停', '亨', '享'],
    ['苗', '笛'],
    ['描', '猫'],
    ['歩', '步', '渉', '涉'],
    ['刹', '剎'],
    ['荻', '萩'],
    ['薮', '藪'],
    ['苫', '苦'],
    ['鎭', '鎮'],
    ['蘭', '蘭'],
    ['貢', '真', '眞', '真'],
    ['単', '单', '單'],
    ['鼻', '梟'],
    ['條', '条'],
    ['爾', '璽'],
    ['爽', '夾', '來', '来'],
    ['那', '耶'],
    ['彦', '彥'],
    ['輿', '與', '興', '嶼'],
    ['牛', '午'],
    ['矢', '失'],
    ['穗', '穂', '徳', '德'],
    ['曉', '暁'],
    ['⿊', '黑', '黒'],
    ['浅', '淺'],
    ['夢', '梦'],
    ['籠', '蘒', '藉', '篠', '種'],
    ['蔵', '葳'],
    ['藝', '蕓'],
    ['遥', '遙'],
    ['龚', '龔'],
    ['卷', '巻'],
    ['ケ', 'ヶ'],
    ['宣', '宜'],
    ['京', '亰'],
    ['増', '增'],
    ['濱', '濵'],
    ['蚤', '蚉', '蛮', '蜜'],
    ['凛', '凜'],
    ['呉', '吳', '吴', '旲', '昊'],
    ['箕', '簑', '蓑'],
    ['⼣', '夕', 'タ'],
    ['您', '悠'],
    ['批', '玭'],
    ['貞', '奌'],
    ['暻', '曝'],
    ['霽', '霖'],
    ['布', '市'],
    ['青', '靑', '⾭', '菁'],
    ['⾹', '香', '沓'],
    ['⾲', '韭'],
    ['⾳', '音'],
    ['⾴', '頁'],
    ['⾵', '風'],
    ['⾶', '飛'],
    ['⾸', '首'],
    ['⾺', '馬'],
    ['⾻', '骨'],
    ['高', '髙', '嵩'],
    ['⾽', '髟'],
    ['⾾', '鬥'],
    ['⾿', '鬯'],
    ['⿀', '鬲'],
    ['⿁', '鬼', '兎', '兜'],
    ['実', '美', '茉', '芙', '末', '未'],
    ['夭', '夫', '未', '末'],
    ['鱗', '麟'],
    ['書', '晝', '畫'],
    ['吃', '屹'],
    ['輝', '暉', '揮'],
    ['剱', '劔', '劍', '剣'],
    ['箇', '薗', '菌', '園', '圓'],
    ['雍', '擁'],
    ['会', '夽'],
    ['瀧', '滝'],
    ['邊', '邉'],
    ['築', '策', '笑'],
    ['季', '李', '李'],
    ['館', '舘'],
    ['曽', '曾', '會'],
    ['戸', '尸', '户', '戶', '芦'],
    ['和', '知'],
    ['崎', '﨑'],
    ['恵', '惠'],
    ['亮', '克'],
    ['煕', '熙'],
    ['亨', '享'],
    ['斉', '齊', '斎', '齋'],
    ['徳', '德'],
    ['鋭', '銳', '鄭', '鄭󠄀'],
    ['辻', '辻󠄀'],
    ['宏', '広'],
    ['本', '木'],
    ['汰', '太', '犬', '大'],
    ['日', '曰'],
    ['己', '已', '巳'],
    ['人', '入'],
    ['道', '違'],
    ['専', '專'],
    ['健', '建'],
    ['裕', '祐', '祐︀', '佑'],
    ['坂', '阪'],
    ['繁', '繫', '敏'],
    ['櫛', '節'],
    ['藤', '籐', '騰', '滕', '縢', '謄'],
    ['韭', '非'],
    ['瑠', '琉'],
    ['惇', '淳'],
    ['偉', '倬'],
    ['欽', '鉄'],
    ['峻', '竣'],
    ['諒', '涼'],
    ['臼', '𦥑', '白'],
    ['仲', '中'],
    ['佐', '左'],
    ['感', '惑'],
    ['職', '識', '織'],
    ['间', '間'],
    ['雄', '雌'],
    ['水', '氷', '永'],
    ['王', '玉', '主', '生'],
    ['田', '由', '甲', '申'],
    ['日', '田', '目', '白'],
    ['老', '孝', '考'],
    ['緑', '縁', '緣'],
    ['販', '敗'],
    ['雲', '雪', '雷'],
    ['万', '方'],
    ['名', '各'],
    ['国', '囯', '國'],
    ['挙', '拳'],
    ['体', '休'],
    ['待', '持', '侍'],
    ['內', '内', '肉'],
    ['黄', '黃'],
    ['酉', '西'],
    ['湖', '蝴'],
    ['原', '厡'],
    ['英', '榮', '栄'],
    ['村', '朾'],
    ['伽', '加'],
    ['昍', '明', '朋'],
    ['鑓', '鐘'],
    ['蓜', '配', '龍'],
    ['桂', '佳'],
    ['磤', '溵'],
    ['龜', '亀'],
    ['静', '靜'],
    ['䂖', '石'],
    ['晴', '晴'],
    ['喧', '暄'],
    ['姬', '姫'],
    ['花', '椛'],
    ['葵', '蒹'],
    ['章', '童'],
    ['嗟', '咲'],
    ['澤', '零', '澪', '濡'],
    ['汫', '井', '丼'],
    ['怜', '怆'],
    ['錄', '録'],
    ['穩', '穏'],
    ['莊', '荘'],
    ['向', '尚'],
    ['强', '強'],
    ['瑢', '璿'],
    ['⿎', '鼓', '皷'],
    ['瑶', '揺', '瑤'],
    ['𨓜', '逸'],
    ['蓝', '藍'],
    ['懯', '慜'],
    ['竈', '竜'],
    ['住', '佳'],
    ['朴', '林'],
    ['妹', '姝'],
    ['淑', '琡'],
    ['黙', '然'],
    ['束', '東'],
    ['晧', '皓'],
    ['台', '合'],
    ['比', '此', '北'],
    ['郎', '朗', '朗'],
    ['羽', '羽'],
    ['準', '隼'],
    ['物', '牣'],
    ['祭', '察', '際'],
    ['亜', '亞', '亚'],
    ['柳', '栁'],
    ['贾', '買', '貴', '貫', '賈', '賣', '寳', '寶', '實', '賽', '塞', '寛', '寬'],
    ['洋', '祥', '祥'],
    ['上', '土', '士'],
    ['卜', 'ト', '⼘'],
    ['工', 'エ'],
    ['⼒', '力', 'カ', 'ヵ'],
    ['糸', '系'],
    ['巣', '巢'],
    ['將', '将'],
    ['輪', '倫'],
    ['律', '津'],
    ['似', '以'],
    ['夘', '卯'],
    ['瑩', '塋', '營'],
    ['舖', '舗'],
    ['顔', '顏'],
    ['隈', '隅'],
    ['昂', '昴'],
    ['拵', '栫', '椋'],
    ['埼', '琦'],
    ['攵', '夂'],
    ['堂', '蛍'],
    ['刁', '刀'],
    ['奥', '奧'],
    ['溪', '渓'],
    ['鍵', '鑓'],
    ['柴', '紫'],
    ['隆', '隆'],
    ['瑛', '暎'],
    ['嗚', '嶋'],
    ['菅', '管', '营'],
    ['磯', '礒'],
    ['厳', '巌'],
    ['瑞', '端'],
    ['慎', '槙', '槇', '愼'],
    ['辛', '幸'],
    ['風', '凪'],
    ['充', '允'],
    ['満', '满'],
    ['豐', '豊'],
    ['坦', '垣'],
    ['輌', '輛'],
    ['桒', '桒'],
    ['薪', '新'],
    ['撤', '徹', '轍'],
    ['浩', '皓'],
    ['児', '兒', '皃'],
    ['見', '身'],
    ['塲', '場'],
    ['惟', '椎'],
    ['縣', '懸'],
    ['宇', '字'],
    ['善', '喜'],
    ['謙', '兼'],
    ['讓', '謙', '譲', '穣', '穰'],
    ['⾷', '食', '倉'],
    ['絢', '絇'],
    ['髮', '髪'],
    ['辰', '振'],
    ['橋', '槗', '𣘺', '𫞏', '槁'],
    ['且', '旦', '亘'],
    ['歲', '歳', '戚', '威'],
    ['杦', '枚', '牧'],
    ['弌', '式', '弎', '弐'],
    ['弑', '弒'],
    ['當', '富', '冨'],
    ['戎', '戒'],
    ['蒋', '蔣'],
    ['憂', '愛', '爱'],
    ['栗', '粟'],
    ['㟢', '嵜', '寄'],
    ['糀', '椛'],
    ['康', '廉', '簾'],
    ['敬', '敏', '敏'],
    ['渚', '渚', '褚', '椿', '楮', '禇'],
    ['麿', '磨', '摩'],
    ['叉', '又'],
    ['緖', '緒'],
    ['～', '〜'], // 〜 is the correct one for long vowel
];
